import { STATUS, TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { isRawPortionedGroup, isWeighableGroup } from '@/utils/mealServingTotals'

export const STATUS_TONE = {
  WEIGHED: 'weighed',
  SHORT: 'short',
  PENDING: 'pending',
  NOT_SUMMING: 'not-summing',
  RAW_PORTIONED: 'raw-portioned'
}

const CHIP_TONES = [STATUS_TONE.WEIGHED, STATUS_TONE.SHORT, STATUS_TONE.RAW_PORTIONED]

export function describeGroupStatus (group) {
  if (isRawPortionedGroup(group)) {
    return { tone: STATUS_TONE.RAW_PORTIONED, label: TEXTS.RAW_PORTIONED_STATUS }
  }
  if (!isWeighableGroup(group)) {
    return { tone: STATUS_TONE.NOT_SUMMING, label: TEXTS.NOT_SUMMING_CELL }
  }
  if (group.status === STATUS.WEIGHED) {
    return { tone: STATUS_TONE.WEIGHED, label: TEXTS.WEIGHED_STATUS }
  }
  if (group.status === STATUS.SHORT_WEIGHED) {
    return { tone: STATUS_TONE.SHORT, label: TEXTS.SHORT_STATUS }
  }
  return { tone: STATUS_TONE.PENDING, label: TEXTS.TO_WEIGH_STATUS }
}

export function canOpenGroup (group) {
  return !isRawPortionedGroup(group)
}

export function hasStatusChip (group) {
  return CHIP_TONES.includes(describeGroupStatus(group).tone)
}

export function describeGroupAction (group) {
  const tone = describeGroupStatus(group).tone
  if (tone === STATUS_TONE.PENDING) {
    return TEXTS.WEIGH_ACTION
  }
  return tone === STATUS_TONE.SHORT ? TEXTS.WEIGH_AGAIN_ACTION : ''
}
